import LayoutDetail from './LayoutDetail';

export default LayoutDetail;
